module.exports = __webpack_public_path__ + "img/hiw-cover.21c19522.png";